export const agentAvatarIds = Array.from(
  { length: 20 },
  (_, index) => `agent-${String(index + 1).padStart(2, "0")}`,
);

export const agentAvatarUrl = (id: string) =>
  id === "viby-v1"
    ? "/avatars/viby-v1.png"
    : `/avatars/realistic-v1/${id}.webp`;
